import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'

import {
	getEvents,
} from '../../../state/events'

import {
	useFavoriteEvents
} from '../../../hooks/events'

import {
	useOnDemandCategories,
	useOnDemandVideos
} from '../../OnDemand/hooks'

import {useDebounceCallback} from '@react-hook/debounce'

import {
	useOnboardingPipelineTriggers,
	useOnboardingPipeline
} from '../hooks'

import {
	applyUpdatesToAssignedPipelines,
	setPipelineAssignmentsEditor,
	setUpdateAssignmentsModal
} from '../slice'

import {usePrograms} from '../../programs/hooks'

import {nMap,capitalize,ellipsis} from '../../../util/util'

import {Link} from 'react-router-dom'

import {
	createOnboardingPipelineTrigger,
	deleteOnboardingPipelineTrigger,
	deleteOnboardingPipelineItem,
	updateOnboardingPipelineItem,
	createOnboardingPipelineItem,
	updateOnboardingPipeline,
	setPipelineAssignModal,
	setEditItemModal,
	setAddItemModal,
} from '../slice'

import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import Select from 'react-select'

const ITEM_OPTIONS = [
	{label:'Program Sample',value:'program'},
	{label:'Message',value:'message'},
	{label:'Workout',value:'workout'},
	{label:'Task',value:'task'},
	{label:'Nutrition',value:'nutrition'},
	{label:'On Demand Video',value:'on_demand_video'},
]

const Item = ({item})=>{
	const dispatch = useDispatch()
	const handleClick = e=>{
		e.stopPropagation()
		dispatch(setEditItemModal({
			id:item.id,
			show:true
		}))
	}

	const [itemPending,setItemPending] = useState(false)

	const shortText = (()=>{
		switch(item.item_type){
			case "on_demand_video": return item.resource.name
			case "program": return (
				<>
					{ellipsis(item.resource.programName,40)}
					<small className="d-block text-info">
						Day {item.program_day}/{item.sample_length}
					</small>
				</>
			)
			case "task": 
			case "workout":
			case "nutrition": return ellipsis(item.resource?.note || `${item.resource?'Untitled':'Deleted'} ${capitalize(item.item_type)}`,40)
			case "message": return ellipsis(item.content,40)
			default: return `Unsupported Item Type: ${item.item_type}`
		}
	})()

	const icon = {
		on_demand_video:<i className="fa fa-video"/>,
		program:<i className="fa fa-clipboard"/>,
		workout:<i className="fa fa-dumbbell"/>,
		nutrition:<i className="fa fa-apple-alt"/>,
		task:<i className="fa fa-check"/>,
		message:<i className="fa fa-comment"/>,
	}[item.item_type]

	const title = {
		on_demand_video:'On Demand Video',
		program:'Program Sample',
		workout:'Workout',
		nutrition:'Nutrition',
		task:'Task',
		message:'Message',
	}[item.item_type]

	return (
		<div onClick={handleClick} className="p-1 px-2 border rounded my-2">
			<div className="d-flex justify-content-between align-items-start">
				<div style={{fontSize:'14px'}}>
					{icon} {title}
				</div>
			</div>
			<hr className="my-1"/>
			<small className="d-block">{shortText}</small>
		</div>
	)
}

const Day = ({day})=>{
	const dispatch = useDispatch()

	const params = new URLSearchParams(window.location.search)
	const id = params.get('id')
	const {status,pipeline} = useOnboardingPipeline(id)
	const items = pipeline.days[day] || []

	const handleAddItem = ()=>{
		dispatch(setAddItemModal({show:true,day:day + 1}))
	}

	if(day >= pipeline?.length) return null

	return (
		<div 
			className="border pb-3" 
			style={{
				flex:'0 0 auto',
				width:`${100/7}%`,
				cursor:'pointer'
			}}
			onClick={handleAddItem}
		>
			<div className="px-1 bg-dark text-light">
				{day+1}
			</div>
			<div 
				className="px-1"
			>
				{items.map(item=><Item item={item}/>)}

				<small className="d-block text-center">
					<i className="fa fa-plus text-success"/> Click to add
				</small>
			</div>
		</div>
	)
}

const Week = ({week})=>{
	return (
		<div className="d-flex w-100">
			{nMap(7,day=><Day day={day + week*7}/>)}
		</div>
	)
}

const ProgramSelector = ({selected,onSelect,length,onChangeLength})=>{
	const {status,programs} = usePrograms()
	return (
		<div>
			<strong>Select Program</strong>
			<Form.Control 
				onChange={e=>{
					onSelect(e.target.value)
				}}
				value={selected}
				as="select"
			>
				<option value="none">Select a program</option>
				{programs.map(program=>(
					<option value={program.programID}>
						{program.programName} ({program.programLength} days)
					</option>
				))}
			</Form.Control>
			<strong>Sample Length</strong>
			<Form.Control 
				onChange={e=>{
					onChangeLength(e.target.value)
				}}
				value={length}
			/>
		</div>
	)
}

const OnDemandVideoSelector = ({categoryId,selected,onSelect})=>{
	const {status,videos} = useOnDemandVideos(categoryId)
	return (
		<div>
			<strong>
				Video
			</strong>
			<Form.Control 
				as="select"
				value={selected}
				onChange={e=>{
					onSelect(e.target.value)
				}}
			>
				<option value="none">Select a Video</option>
				{videos.map(video=>(
					<option value={video.id}>
						{video.name} ({video.time})
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const OnDemandSelector = ({selected,onSelect,defaultCategory='none'})=>{
	const {status,categories} = useOnDemandCategories()
	const [category,setCategory] = useState(defaultCategory)
	useEffect(()=>{
		setCategory(defaultCategory)
	},[defaultCategory])
	return (
		<div>
			<strong>Category</strong>
			<Form.Control 
				as="select"
				value={category}
				onChange={e=>{
					setCategory(e.target.value)
				}}
			>
				<option value="none">Select a Category</option>
				{categories.map(category=>(
					<option value={category.id}>
						{category.name}
					</option>
				))}
			</Form.Control>
			{category!=='none'&&
				<OnDemandVideoSelector categoryId={category} selected={selected} onSelect={onSelect}/>
			}
		</div>
	)
}

const EventSelector = ({selected,onSelect,type})=>{
	const events = useFavoriteEvents(type)

	return (
		<div>
			<strong>{capitalize(type)}</strong>
			<Form.Control 
				onChange={e=>{
					onSelect(e.target.value)
				}}
				value={selected}
				as="select"
			>
				<option value="none">Select a {capitalize(type)}</option>
				{events.map(event=>(
					<option value={event[`${type}_id`]}>{event.note || `Untitled ${capitalize(type)}`}</option>
				))}
			</Form.Control>
		</div>
	)
}

const AddItemModal = ({pipelineLength,pipelineId})=>{
	const dispatch = useDispatch()
	const {show,day:defaultDay} = useSelector(
		state => state.growth.pipelines.addItemModal
	)
	const onHide = ()=>{
		dispatch(setAddItemModal({show:false,day:1}))
	}
	const [day,setDay] = useState(defaultDay)
	const [selectedType,setSelectedType] = useState('none')

	const [resourceId,setResourceId] = useState('none')
	const [programSampleLength,setProgramSampleLength] = useState(1)

	const [message,setMessage] = useState('')

	const [addingItem,setAddingItem] = useState(false)
	const handleAddItem = ()=>{
		//validation
		if(selectedType==='none'){
			window.alert('Please select an item type.')
			return
		}
		const resourceTypes = ['program','workout','task','nutrition','on_demand_video']
		if(resourceTypes.includes(selectedType)&&(!resourceId||resourceId==='none')){
			window.alert('Please select an item.')
			return
		}
		if(selectedType==='message'&&message===''){
			window.alert('Please set a message.')
			return
		}
		setAddingItem(true)
		const payload = {
			pipeline_id:pipelineId,
			item_type:selectedType,
			resource_id:resourceId,
			day
		}
		switch(selectedType){
			case "program":
				payload.sample_length = programSampleLength
			break
			case "message":
				payload.content = message
			break

		}
		dispatch(createOnboardingPipelineItem(payload)).then(res=>{
			setAddingItem(false)
			setSelectedType('none')
			setResourceId('none')
			setMessage('')
			setProgramSampleLength(1)
			onHide()
		})
	}

	useEffect(()=>{
		setDay(defaultDay)
	},[defaultDay])

	const itemSelector = {
		program:(
			<ProgramSelector
				selected={resourceId}
				onSelect={setResourceId}
				length={programSampleLength}
				onChangeLength={setProgramSampleLength}
			/>
		),
		message:(
			<div>
				<strong>Message</strong>
				<Form.Control 
					onChange={e=>{
						setMessage(e.target.value)
					}}
					value={message}
					as="textarea" 
					placeholder="message"
				/>
			</div>
		),
		workout:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="workout"
			/>
		),
		task:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="task"
			/>
		),
		nutrition:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="nutrition"
			/>
		),
		on_demand_video:(
			<OnDemandSelector 
				selected={resourceId} 
				onSelect={setResourceId}
			/>
		)
	}[selectedType]

	useEffect(()=>{
		dispatch(getEvents({
			event_type:'workout',
			filter:'favorite'
		}))
		dispatch(getEvents({
			event_type:'task',
			filter:'favorite'
		}))
		dispatch(getEvents({
			event_type:'nutrition',
			filter:'favorite'
		}))
	},[])

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				Add Item to Automation
			</Modal.Header>
			<Modal.Body>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text>Day</InputGroup.Text>
					</InputGroup.Prepend>
					<Form.Control
						onChange={e=>{
							setDay(parseInt(e.target.value))
						}}
						value={day}
					/>
				</InputGroup>
				<strong>Item Type</strong>
				<Form.Control 
					onChange={e=>{
						setSelectedType(e.target.value)
					}}
					as="select"
				>
					<option value="none">Select item type</option>
					{ITEM_OPTIONS.map(({value,label})=>(
						<option value={value}>{label}</option>
					))}
				</Form.Control>
				{itemSelector}
			</Modal.Body>
			<Modal.Footer>
				<Button 
					onClick={handleAddItem}
					variant="outline-success"
					disabled={addingItem}
				>
					Add Item {addingItem&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

const EditItemModal = ({pipelineLength,pipelineId})=>{
	const dispatch = useDispatch()
	const {show,id} = useSelector(
		state => state.growth.pipelines.editItemModal
	)
	const {pipeline} = useOnboardingPipeline(pipelineId)
	const item = pipeline.items.find(item=>item.id===id)
	console.log(item)
	const onHide = ()=>{
		dispatch(setEditItemModal({show:false,id:null}))
	}
	const [day,setDay] = useState(item?.day)
	const [selectedType,setSelectedType] = useState(item?.item_type)

	const [resourceId,setResourceId] = useState(item?.resource_id)
	const [programSampleLength,setProgramSampleLength] = useState(item?.sample_length)

	const [message,setMessage] = useState(item?.content)

	useEffect(()=>{
		if(!item) return 
		setDay(item.day)
		setSelectedType(item.item_type)
		setResourceId(item.resource_id)
		setProgramSampleLength(item.sample_length)
		setMessage(item.content)
	},[item])

	const [itemPending,setItemPending] = useState(false)
	const handleUpdateItem = ()=>{
		if(selectedType==='none'){
			window.alert('Please select an item type.')
			return
		}
		const resourceTypes = ['program','workout','task','nutrition','on_demand_video']
		if(resourceTypes.includes(selectedType)&&(!resourceId||resourceId==='none')){
			window.alert('Please select an item.')
			return
		}
		if(selectedType==='message'&&message===''){
			window.alert('Please set a message.')
			return
		}
		setItemPending(true)
		const payload = {
			id:item.id,
			update:{
				pipeline_id:pipelineId,
				item_type:selectedType,
				resource_id:resourceId,
				sample_length:programSampleLength,
				content:message,
				day
			}
		}
		dispatch(updateOnboardingPipelineItem(payload)).then(res=>{
			setItemPending(false)
			onHide()
		})
	}

	const handleRemoveItem = ()=>{
		if(!window.confirm('Are you sure you want to remove this item?')) return
		setItemPending(true)
		dispatch(deleteOnboardingPipelineItem(item.id)).then(res=>{
			setItemPending(false)
			onHide()
		})
	}

	const itemSelector = {
		program:(
			<ProgramSelector
				selected={resourceId}
				onSelect={setResourceId}
				length={programSampleLength}
				onChangeLength={setProgramSampleLength}
			/>
		),
		message:(
			<div>
				<strong>Message</strong>
				<Form.Control 
					onChange={e=>{
						setMessage(e.target.value)
					}}
					value={message}
					as="textarea" 
					placeholder="message"
				/>
			</div>
		),
		workout:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="workout"
			/>
		),
		task:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="task"
			/>
		),
		nutrition:(
			<EventSelector 
				selected={resourceId} 
				onSelect={setResourceId}
				type="nutrition"
			/>
		),
		on_demand_video:(
			<OnDemandSelector 
				defaultCategory={item?.resource?.category_id}
				selected={resourceId} 
				onSelect={setResourceId}
			/>
		)
	}[selectedType]

	useEffect(()=>{
		dispatch(getEvents({
			event_type:'workout',
			filter:'favorite'
		}))
		dispatch(getEvents({
			event_type:'task',
			filter:'favorite'
		}))
		dispatch(getEvents({
			event_type:'nutrition',
			filter:'favorite'
		}))
	},[])

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				Edit Automation Item
			</Modal.Header>
			<Modal.Body>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text>Day</InputGroup.Text>
					</InputGroup.Prepend>
					<Form.Control
						onChange={e=>{
							setDay(parseInt(e.target.value))
						}}
						value={day}
					/>
				</InputGroup>
				<strong>Item Type</strong>
				<Form.Control 
					value={selectedType}
					onChange={e=>{
						setSelectedType(e.target.value)
					}}
					as="select"
				>
					<option value="none">Select item type</option>
					{ITEM_OPTIONS.map(({value,label})=>(
						<option value={value}>{label}</option>
					))}
				</Form.Control>
				{itemSelector}
			</Modal.Body>
			<Modal.Footer>
				{itemPending&&<Spinner animation="border" size="sm"/>}
				<Button 
					onClick={handleRemoveItem}
					variant="outline-danger"
					disabled={itemPending}
				>
					Remove Item
				</Button>
				<Button 
					onClick={handleUpdateItem}
					variant="outline-success"
					disabled={itemPending}
				>
					Update Item
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

const UpdateAssignmentModal = ({pipelineId})=>{
	const dispatch = useDispatch()

	const [updateAll,setUpdateAll] = useState(false)

	const {show} = useSelector(
		state => state.growth.pipelines.updateAssignmentsModal
	)

	const [selectedAssignments,setSelectedAssignments] = useState([])

	const {pipeline} = useOnboardingPipeline(pipelineId)

	const onHide = ()=>{
		dispatch(setUpdateAssignmentsModal({
			show:false
		}))
	}

	const [isApplying,setIsApplying] = useState(false)
	const applyUpdates = ()=>{
		setIsApplying(true)
		dispatch(applyUpdatesToAssignedPipelines({
			pipeline_id:pipelineId,
			update_all:Number(updateAll),
			user_id_numbers:selectedAssignments.map(({value})=>value)
		})).then(()=>{
			setIsApplying(false)
			setSelectedAssignments([])
			setUpdateAll(false)
			onHide()
		})
	}

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				Update Existing Assignments
			</Modal.Header>
			<Modal.Body>
				<strong>Select Assignment</strong>
				<div className="d-flex my-2">
					<Select
						onChange={setSelectedAssignments}
						value={updateAll?[]:selectedAssignments}
						isDisabled={updateAll}
						className="w-100"
						options={pipeline.users.map((user)=>(
							{value:user.user_id_number,label:user.user_name}
						))}
						placeholder={
							updateAll
							? 'Update All'
							: 'Select'
						}
						isMulti
					/>
					<Button 
						onClick={setUpdateAll.bind(null,p=>!p)}
						className="ml-1"
						variant={updateAll?'primary':"outline-primary"}
					>
						All
					</Button>
				</div>
				<Button 
					onClick={applyUpdates}
					disabled={isApplying}
					variant="outline-success" 
					block
				>
					Apply Updates to Selected Assignments {isApplying&&<Spinner animation='border' size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

export default function PipelineEditor({location}){
	const params = new URLSearchParams(location.search)

	const id = params.get('id')
	const dispatch = useDispatch()

	const {status,pipeline} = useOnboardingPipeline(id)

	const triggersToOptions = triggers=>{
		return triggers.map(trigger=>({
			value:trigger.id,
			label:{
				message:'Chat Message',
				intake_form:'Intake Form',
				incomplete_purchase:'Incomplete Purchase',
				complete_purchase:'Complete Purchase'
			}[trigger.name]
		}))
	}

	const {status:triggersStatus,triggers} = useOnboardingPipelineTriggers()

	const updatePipeline = (update)=>{
		dispatch(updateOnboardingPipeline({id,update}))
	}

	const handleAddTrigger = triggerId => {
		dispatch(createOnboardingPipelineTrigger({
			pipeline_id:id,
			type_id:triggerId
		}))
	}

	const handleRemoveTrigger = triggerId => {
		dispatch(deleteOnboardingPipelineTrigger({
			pipeline_id:id,
			type_id:triggerId
		}))
	}

	const openAssignModal = ()=>{
		dispatch(setPipelineAssignModal({
			show:true,
			id
		}))
	}

	const openAssignmentsEditor = ()=>{
		dispatch(setPipelineAssignmentsEditor({
			show:true,
			id
		}))
	}

	const showUpdateAssignmentsModal = ()=>{
		dispatch(setUpdateAssignmentsModal({
			show:true
		}))
	}

	const debouncedUpdate = useDebounceCallback(updatePipeline,500)

	if(status!=='idle') return (
		<div className="pt-2 px-2 px-md-3">
			<Spinner animation="border"/>
		</div>
	)
	return (
		<div className="pt-2 px-2 px-md-3 pb-5 mb-5">
			<div>
				<Link to="/growth?tab=pipelines">
					Automations
				</Link>
				<span className="d-inline-block mx-2">
					/
				</span>
				<strong>Automation Editor</strong>
			</div>
			<hr/>
			<div className="d-flex justify-content-between">
				<div className="mr-2" style={{flex:'1 1 auto'}}>
					<strong>Name</strong>
					<Form.Control 
						defaultValue={pipeline.name}
						onChange={e=>{
							debouncedUpdate({name:e.target.value})
						}}
					/>
				</div>
				<div style={{width:'200px',flex:'0 0 auto'}}>
					<strong>Length (days)</strong>
					<Form.Control 
						defaultValue={pipeline.length}
						onChange={e=>{
							debouncedUpdate({length:parseInt(e.target.value)})
						}}
					/>
				</div>
			</div>
			{/*
			<div>
				<strong>Triggers (optional)</strong>
				<Select 
					defaultValue={triggersToOptions(pipeline.triggers)}
					onChange={(selectedTriggers,payload)=>{
						if ( payload.action === 'select-option' ) {
							handleAddTrigger(payload.option.value)
						} else if( payload.action === 'remove-value' ) {
							handleRemoveTrigger(payload.removedValue.value)
						} else if( payload.action === 'clear') {
							triggers.forEach(trigger=>{
								handleRemoveTrigger(trigger.id)
							})
						}
					}}
					options={triggersToOptions(triggers)}
					isMulti
				/>
				<small>
					<i className="fa fa-info-circle"/> Triggers will automatically assign automation to prospective clients when they do certain actions (e.g. fill out an intake form, send a message or don't complete a purchase)
				</small>
			</div>
			*/}
			<div>
				<strong className="d-block">
					Assign Automation
				</strong>
				<small className="d-block">
					You can manually assign automations to prospects if the automatic triggers above do not work for you. 
				</small>
				<Button variant="outline-primary" onClick={openAssignmentsEditor} className="mr-1">
					View Existing Assignments
				</Button>
				<Button variant="outline-success" onClick={openAssignModal}>
					Assign automation to prospective client
				</Button>
			</div>
			<div className="w-100 mt-3">
				{nMap(
					Math.ceil(pipeline.length/7),
					week => <Week week={week}/>
				)}
			</div>
			<div className="mt-2">
				<strong className="d-block">
					Manage Automation Assignments
				</strong>
				<Button 
					variant="outline-primary" 
					onClick={showUpdateAssignmentsModal} 
					block
				>
					Apply Updates to Existing Assignments
				</Button>
				<small className="d-block">
					<i className="fa fa-info-circle mr-1"/>
					Updates to programs, workouts, tasks & nutrtion on automations do not automatically apply to existing assignments. 
				</small>
			</div>
			<AddItemModal pipelineLength={pipeline.length} pipelineId={id}/>
			<EditItemModal pipelineLength={pipeline.length} pipelineId={id}/>
			<UpdateAssignmentModal pipelineId={id}/>
		</div>
	)
}
